import { graphql } from '../../gql';

export const POSTING_DISCOVERY_QUERY = graphql(`
  query PostingDiscoveryQuery($query: PostingDiscoveryReq) {
    posting_discovery_search(query: $query) {
      postings {
        job_id
        rcid
        company_id
        company_name
        rics_k400
        rics_k50
        rics_k10
        post_date
        role_v3_id
        state
        country
        msa
        city
        region
        seniority
        remote_type
        salary
        skills
        description
        jobtitle
        posting_url
        location
        expected_hires
      }
      pagination {
        tot_pages_num
        tot_postings_num
      }
      map_data {
        id
        map_data_kind
        count
        share
        lat
        lon
        location
      }
      columns
    }
  }
`);
